/**
 * Payload shapes of the ICD-10-GM release, as converted from the BfArM's
 * machine-readable files (ClaML + metadata) by `convert-icd10gm.ts`. Stored on
 * the catalog ICD rows and returned unchanged. The BfArM's download conditions
 * forbid changing the codes, their texts and the coding notes, so these shapes
 * carry the text verbatim — only the layout (paragraphs, lists, fragments) is
 * flattened into lines.
 */
/**
 * The sentence the BfArM's download conditions require in every machine-readable
 * copy of the ICD-10-GM — carried in the converted file and shown wherever its
 * text is.
 */
export const BFARM_ATTRIBUTION = 'Die Erstellung erfolgt unter Verwendung der maschinenlesbaren Fassung des Bundesinstituts für Arzneimittel und Medizinprodukte (BfArM).';
/** The ClaML class kind: a chapter (`VI`), a block (`G20-G26`) or a code (`G24`). */
export var IcdClassKind;
(function (IcdClassKind) {
    IcdClassKind["CHAPTER"] = "chapter";
    IcdClassKind["BLOCK"] = "block";
    IcdClassKind["CATEGORY"] = "category";
})(IcdClassKind || (IcdClassKind = {}));
/** The Kreuz-Stern system: dagger (†), aster (*) or the optional (!) mark. */
export var IcdUsageMark;
(function (IcdUsageMark) {
    IcdUsageMark["DAGGER"] = "dagger";
    IcdUsageMark["ASTER"] = "aster";
    IcdUsageMark["OPTIONAL"] = "optional";
})(IcdUsageMark || (IcdUsageMark = {}));
/**
 * How a code may be used under §295 SGB V (Feld 13 of the BfArM metadata) — the
 * outpatient rule, which is the one a Verordnung follows.
 */
export var IcdCodingUse;
(function (IcdCodingUse) {
    /** P — zur Primärverschlüsselung zugelassen. */
    IcdCodingUse["PRIMARY"] = "P";
    /** O — nur als Sternschlüsselnummer zugelassen. */
    IcdCodingUse["ASTER_ONLY"] = "O";
    /** Z — nur als Ausrufezeichenschlüsselnummer zugelassen. */
    IcdCodingUse["OPTIONAL_ONLY"] = "Z";
    /** V — nicht zur Verschlüsselung zugelassen (e.g. a non-terminal `G24.-`). */
    IcdCodingUse["NOT_CODABLE"] = "V";
})(IcdCodingUse || (IcdCodingUse = {}));
/** The ClaML rubric kinds a reader is shown (titles live on the entry itself). */
export var IcdRubricKind;
(function (IcdRubricKind) {
    IcdRubricKind["INCLUSION"] = "inclusion";
    IcdRubricKind["EXCLUSION"] = "exclusion";
    IcdRubricKind["NOTE"] = "note";
    IcdRubricKind["CODING_HINT"] = "coding-hint";
    IcdRubricKind["DEFINITION"] = "definition";
    IcdRubricKind["INTRODUCTION"] = "introduction";
    IcdRubricKind["TEXT"] = "text";
})(IcdRubricKind || (IcdRubricKind = {}));
//# sourceMappingURL=icd-payloads.js.map